export const API_ENDPOINTS = {
    // Auth
    LOGIN: '/api/v1/auth/login',
    LOGOUT: '/api/v1/auth/logout',
    PROFILE: '/api/v1/me',

    // Incidents
    INCIDENTS: '/api/v1/incidents',
    INCIDENT_STATS: '/api/v1/stats',

    // Suggestions
    SUGGESTIONS: (id: string) => `/api/v1/incidents/${id}/suggestions`,

    // Companies
    COMPANIES: '/api/v1/companies',

    // Users
    USERS: '/api/v1/users',
    UPDATE_USER_ROLE: (userId: string) => `/api/v1/users/${userId}/role`,
};
